import EmberObject from '@ember/object';

export function computeFromComponentValues(c1, c2, r1, r2, r5, gbw) {
  var gain = r5 / r1;
  var sqrtTerm = Math.sqrt(r2 * r5 * c1 * c2);
  var fpPrime = 1 / (2 * Math.PI * sqrtTerm);
  var woPrime = 1 / sqrtTerm;

  var qPrime = 1 / (((1 / c1) * (1 / r1 + 1 / r2 + 1 / r5)) / woPrime);
  var gbwMod = Math.sqrt(1 + (gain * gain) / (2 * Math.PI * r2 * c2 * gbw));

  var q = qPrime * gbwMod;
  var fp = fpPrime / gbwMod;

  var result = EmberObject.create({ stageQ: q, stageFp: fp, gain: gain });
  return result;
}

export function execute(circuit) {
  var r1 = circuit.r1.value;
  var r2 = circuit.r2.value;
  var r5 = circuit.r5.value;
  var c1 = circuit.c1.value;
  var c2 = circuit.c2.value;
  var gbw = circuit.opAmp.gbw;
  return this.computeFromComponentValues(c1, c2, r1, r2, r5, gbw);
}
